/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NovitusBarcodeDto } from './NovitusBarcodeDto';
import {
    NovitusBarcodeDtoFromJSON,
    NovitusBarcodeDtoFromJSONTyped,
    NovitusBarcodeDtoToJSON,
} from './NovitusBarcodeDto';
import type { NovitusAsciiArtDto } from './NovitusAsciiArtDto';
import {
    NovitusAsciiArtDtoFromJSON,
    NovitusAsciiArtDtoFromJSONTyped,
    NovitusAsciiArtDtoToJSON,
} from './NovitusAsciiArtDto';
import type { NovitusQrcodeTextDto } from './NovitusQrcodeTextDto';
import {
    NovitusQrcodeTextDtoFromJSON,
    NovitusQrcodeTextDtoFromJSONTyped,
    NovitusQrcodeTextDtoToJSON,
} from './NovitusQrcodeTextDto';
import type { NovitusSpecialLineDto } from './NovitusSpecialLineDto';
import {
    NovitusSpecialLineDtoFromJSON,
    NovitusSpecialLineDtoFromJSONTyped,
    NovitusSpecialLineDtoToJSON,
} from './NovitusSpecialLineDto';
import type { NovitusGraphicDto } from './NovitusGraphicDto';
import {
    NovitusGraphicDtoFromJSON,
    NovitusGraphicDtoFromJSONTyped,
    NovitusGraphicDtoToJSON,
} from './NovitusGraphicDto';
import type { NovitusTextlineDto } from './NovitusTextlineDto';
import {
    NovitusTextlineDtoFromJSON,
    NovitusTextlineDtoFromJSONTyped,
    NovitusTextlineDtoToJSON,
} from './NovitusTextlineDto';

/**
 * 
 * @export
 * @interface NovitusPrintoutLineDto
 */
export interface NovitusPrintoutLineDto {
    /**
     * Zawartość linii tekstowej
     * @type {NovitusTextlineDto}
     * @memberof NovitusPrintoutLineDto
     */
    textline?: NovitusTextlineDto;
    /**
     * Zawartość kodu kreskowego
     * @type {NovitusBarcodeDto}
     * @memberof NovitusPrintoutLineDto
     */
    barcode?: NovitusBarcodeDto;
    /**
     * Zawartość kodu QR
     * @type {NovitusQrcodeTextDto}
     * @memberof NovitusPrintoutLineDto
     */
    qrcode?: NovitusQrcodeTextDto;
    /**
     * Linia specjalna
     * @type {NovitusSpecialLineDto}
     * @memberof NovitusPrintoutLineDto
     */
    special_line?: NovitusSpecialLineDto;
    /**
     * Grafika
     * @type {NovitusGraphicDto}
     * @memberof NovitusPrintoutLineDto
     */
    graphic?: NovitusGraphicDto;
    /**
     * ASCII Art
     * @type {NovitusAsciiArtDto}
     * @memberof NovitusPrintoutLineDto
     */
    ascii_art?: NovitusAsciiArtDto;
}

/**
 * Check if a given object implements the NovitusPrintoutLineDto interface.
 */
export function instanceOfNovitusPrintoutLineDto(value: object): value is NovitusPrintoutLineDto {
    return true;
}

export function NovitusPrintoutLineDtoFromJSON(json: any): NovitusPrintoutLineDto {
    return NovitusPrintoutLineDtoFromJSONTyped(json, false);
}

export function NovitusPrintoutLineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPrintoutLineDto {
    if (json == null) {
        return json;
    }
    return {
        
        'textline': json['textline'] == null ? undefined : NovitusTextlineDtoFromJSON(json['textline']),
        'barcode': json['barcode'] == null ? undefined : NovitusBarcodeDtoFromJSON(json['barcode']),
        'qrcode': json['qrcode'] == null ? undefined : NovitusQrcodeTextDtoFromJSON(json['qrcode']),
        'special_line': json['special_line'] == null ? undefined : NovitusSpecialLineDtoFromJSON(json['special_line']),
        'graphic': json['graphic'] == null ? undefined : NovitusGraphicDtoFromJSON(json['graphic']),
        'ascii_art': json['ascii_art'] == null ? undefined : NovitusAsciiArtDtoFromJSON(json['ascii_art']),
    };
}

export function NovitusPrintoutLineDtoToJSON(value?: NovitusPrintoutLineDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'textline': NovitusTextlineDtoToJSON(value['textline']),
        'barcode': NovitusBarcodeDtoToJSON(value['barcode']),
        'qrcode': NovitusQrcodeTextDtoToJSON(value['qrcode']),
        'special_line': NovitusSpecialLineDtoToJSON(value['special_line']),
        'graphic': NovitusGraphicDtoToJSON(value['graphic']),
        'ascii_art': NovitusAsciiArtDtoToJSON(value['ascii_art']),
    };
}

